var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataCollectEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 671.436,
    viewBox: "0 0 800 671.436",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-332 61.473)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(572.559 177.193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.18,488.291c0,.611.335,1.1.751,1.1h374.65c.42,0,.751-.49.751-1.1s-.335-1.1-.751-1.1H15.931C15.515,487.191,15.18,487.681,15.18,488.291Z",
    transform: "translate(75.763 -56.622)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.376,
    height: 2.36,
    transform: "translate(213.659 428.039)",
    fill: "#94a3b8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.376,
    height: 2.36,
    transform: "translate(332.077 428.433)",
    fill: "#94a3b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.831,370.945a19.274,19.274,0,0,1-38.033,0H229.146V476.381H364.485V370.945Z",
    transform: "translate(-17.094 -47.95)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 135.336,
    height: 3.67,
    transform: "translate(212.446 420.078)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.9,347.661H7.545A7.553,7.553,0,0,1,0,340.117V29.456a7.553,7.553,0,0,1,7.545-7.546H551.9a7.554,7.554,0,0,1,7.545,7.545V340.117a7.554,7.554,0,0,1-7.545,7.545Z",
    transform: "translate(0 -21.911)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H532.689V300.572H0Z",
    transform: "translate(11.275 11.88)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2,0H511.71a4.2,4.2,0,0,1,4.2,4.2V285.189a4.2,4.2,0,0,1-4.2,4.2H4.2a4.2,4.2,0,0,1-4.2-4.2V4.2A4.2,4.2,0,0,1,4.2,0Z",
    transform: "translate(21.768 17.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.594,0H120.28a5.594,5.594,0,0,1,5.594,5.594V78.322a5.594,5.594,0,0,1-5.594,5.594H5.594A5.594,5.594,0,0,1,0,78.322V5.594A5.594,5.594,0,0,1,5.594,0Z",
    transform: "translate(63.636 76.923)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.594,0H120.28a5.594,5.594,0,0,1,5.594,5.594V78.322a5.594,5.594,0,0,1-5.594,5.594H5.594A5.594,5.594,0,0,1,0,78.322V5.594A5.594,5.594,0,0,1,5.594,0Z",
    transform: "translate(216.783 76.923)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8,0h120.28a2.8,2.8,0,0,1,2.8,2.8v8.392a2.8,2.8,0,0,1-2.8,2.8H2.8a2.8,2.8,0,0,1-2.8-2.8V2.8A2.8,2.8,0,0,1,2.8,0Z",
    transform: "translate(63.636 188.112)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8,0h120.28a2.8,2.8,0,0,1,2.8,2.8v8.392a2.8,2.8,0,0,1-2.8,2.8H2.8a2.8,2.8,0,0,1-2.8-2.8V2.8A2.8,2.8,0,0,1,2.8,0Z",
    transform: "translate(63.636 213.287)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8,0H46.042a2.8,2.8,0,0,1,2.8,2.8v8.392a2.8,2.8,0,0,1-2.8,2.8H2.8a2.8,2.8,0,0,1-2.8-2.8V2.8A2.8,2.8,0,0,1,2.8,0Z",
    transform: "translate(63.636 238.462)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8,0h120.28a2.8,2.8,0,0,1,2.8,2.8v8.392a2.8,2.8,0,0,1-2.8,2.8H2.8a2.8,2.8,0,0,1-2.8-2.8V2.8A2.8,2.8,0,0,1,2.8,0Z",
    transform: "translate(216.783 188.112)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8,0h120.28a2.8,2.8,0,0,1,2.8,2.8v8.392a2.8,2.8,0,0,1-2.8,2.8H2.8a2.8,2.8,0,0,1-2.8-2.8V2.8A2.8,2.8,0,0,1,2.8,0Z",
    transform: "translate(216.783 213.287)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8,0H46.042a2.8,2.8,0,0,1,2.8,2.8v8.392a2.8,2.8,0,0,1-2.8,2.8H2.8a2.8,2.8,0,0,1-2.8-2.8V2.8A2.8,2.8,0,0,1,2.8,0Z",
    transform: "translate(216.783 238.462)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.594,0H120.28a5.594,5.594,0,0,1,5.594,5.594V78.322a5.594,5.594,0,0,1-5.594,5.594H5.594A5.594,5.594,0,0,1,0,78.322V5.594A5.594,5.594,0,0,1,5.594,0Z",
    transform: "translate(365.734 76.923)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8,0h120.28a2.8,2.8,0,0,1,2.8,2.8v8.392a2.8,2.8,0,0,1-2.8,2.8H2.8a2.8,2.8,0,0,1-2.8-2.8V2.8A2.8,2.8,0,0,1,2.8,0Z",
    transform: "translate(365.734 188.112)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8,0h120.28a2.8,2.8,0,0,1,2.8,2.8v8.392a2.8,2.8,0,0,1-2.8,2.8H2.8a2.8,2.8,0,0,1-2.8-2.8V2.8A2.8,2.8,0,0,1,2.8,0Z",
    transform: "translate(365.734 213.287)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8,0H46.042a2.8,2.8,0,0,1,2.8,2.8v8.392a2.8,2.8,0,0,1-2.8,2.8H2.8a2.8,2.8,0,0,1-2.8-2.8V2.8A2.8,2.8,0,0,1,2.8,0Z",
    transform: "translate(365.734 238.462)",
    fill: "#234ba2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(332 -57.413)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 89.994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.393,0H301.4A10.393,10.393,0,0,1,311.8,10.393V24.251A10.393,10.393,0,0,1,301.4,34.644H10.393A10.393,10.393,0,0,1,0,24.251V10.393A10.393,10.393,0,0,1,10.393,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.393,1.732a8.671,8.671,0,0,0-8.661,8.661V24.251a8.671,8.671,0,0,0,8.661,8.661H301.4a8.671,8.671,0,0,0,8.661-8.661V10.393A8.671,8.671,0,0,0,301.4,1.732H10.393m0-1.732H301.4A10.393,10.393,0,0,1,311.8,10.393V24.251A10.393,10.393,0,0,1,301.4,34.644H10.393A10.393,10.393,0,0,1,0,24.251V10.393A10.393,10.393,0,0,1,10.393,0Z",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.393,0A10.393,10.393,0,1,1,0,10.393,10.393,10.393,0,0,1,10.393,0Z",
    transform: "translate(20.787 6.929)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.393,0A10.393,10.393,0,1,1,0,10.393,10.393,10.393,0,0,1,10.393,0Z",
    transform: "translate(62.36 6.929)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.393,0A10.393,10.393,0,1,1,0,10.393,10.393,10.393,0,0,1,10.393,0Z",
    transform: "translate(103.933 6.929)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.393,0A10.393,10.393,0,1,1,0,10.393,10.393,10.393,0,0,1,10.393,0Z",
    transform: "translate(145.506 6.929)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.393,0A10.393,10.393,0,1,1,0,10.393,10.393,10.393,0,0,1,10.393,0Z",
    transform: "translate(187.079 6.929)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.393,0A10.393,10.393,0,1,1,0,10.393,10.393,10.393,0,0,1,10.393,0Z",
    transform: "translate(228.652 6.929)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.393,0A10.393,10.393,0,1,1,0,10.393,10.393,10.393,0,0,1,10.393,0Z",
    transform: "translate(270.225 6.929)",
    fill: "#f1f5f9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(481.303 137.322)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 81,
    rx: 6,
    transform: "translate(-0.303 -0.322)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4,1.7A1.7,1.7,0,0,0,1.7,3.4V77.1a1.7,1.7,0,0,0,1.7,1.7H78.233a1.7,1.7,0,0,0,1.7-1.7V3.4a1.7,1.7,0,0,0-1.7-1.7H3.4M3.4,0H78.233a3.4,3.4,0,0,1,3.4,3.4V77.1a3.4,3.4,0,0,1-3.4,3.4H3.4A3.4,3.4,0,0,1,0,77.1V3.4A3.4,3.4,0,0,1,3.4,0Z",
    transform: "translate(0 0)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 13.606)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 26.078)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 38.55)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 51.021)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 63.493)",
    fill: "#234ba2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(373.648 40.86) rotate(20)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.634,
    height: 55.557,
    rx: 6,
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4,1.7A1.7,1.7,0,0,0,1.7,3.4V52.155a1.7,1.7,0,0,0,1.7,1.7H78.233a1.7,1.7,0,0,0,1.7-1.7V3.4a1.7,1.7,0,0,0-1.7-1.7H3.4M3.4,0H78.233a3.4,3.4,0,0,1,3.4,3.4V52.155a3.4,3.4,0,0,1-3.4,3.4H3.4a3.4,3.4,0,0,1-3.4-3.4V3.4A3.4,3.4,0,0,1,3.4,0Z",
    transform: "translate(0 0)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 13.606)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 26.078)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 38.55)",
    fill: "#234ba2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.165 25.366)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 55,
    rx: 6,
    transform: "translate(-0.165 0.633)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4,1.7A1.7,1.7,0,0,0,1.7,3.4V52.155a1.7,1.7,0,0,0,1.7,1.7H78.233a1.7,1.7,0,0,0,1.7-1.7V3.4a1.7,1.7,0,0,0-1.7-1.7H3.4M3.4,0H78.233a3.4,3.4,0,0,1,3.4,3.4V52.155a3.4,3.4,0,0,1-3.4,3.4H3.4a3.4,3.4,0,0,1-3.4-3.4V3.4A3.4,3.4,0,0,1,3.4,0Z",
    transform: "translate(0.019 0)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.625 13.606)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.625 26.078)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.625 38.55)",
    fill: "#234ba2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 245.393, -4.067)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 81,
    rx: 6,
    transform: "translate(0.065 0.001)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4,1.7A1.7,1.7,0,0,0,1.7,3.4V77.1a1.7,1.7,0,0,0,1.7,1.7H78.233a1.7,1.7,0,0,0,1.7-1.7V3.4a1.7,1.7,0,0,0-1.7-1.7H3.4M3.4,0H78.233a3.4,3.4,0,0,1,3.4,3.4V77.1a3.4,3.4,0,0,1-3.4,3.4H3.4A3.4,3.4,0,0,1,0,77.1V3.4A3.4,3.4,0,0,1,3.4,0Z",
    transform: "translate(0 0.423)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 14.028)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 26.5)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 38.972)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 51.444)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 63.916)",
    fill: "#234ba2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 81,
    rx: 6,
    transform: "translate(0 0.001)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4,1.7A1.7,1.7,0,0,0,1.7,3.4V77.1a1.7,1.7,0,0,0,1.7,1.7H78.233a1.7,1.7,0,0,0,1.7-1.7V3.4a1.7,1.7,0,0,0-1.7-1.7H3.4M3.4,0H78.233a3.4,3.4,0,0,1,3.4,3.4V77.1a3.4,3.4,0,0,1-3.4,3.4H3.4A3.4,3.4,0,0,1,0,77.1V3.4A3.4,3.4,0,0,1,3.4,0Z",
    transform: "translate(0 0.423)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 14.028)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 26.5)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 38.972)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 51.444)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,0H52.722a1.7,1.7,0,1,1,0,3.4H1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(13.606 63.916)",
    fill: "#234ba2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCollectEmptyState);
export default __webpack_public_path__ + "static/media/dataCollect-empty-state.02b2bbf6da90297f8d85f69788127804.svg";
export { ForwardRef as ReactComponent };